import React from "react";
import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import { CreateMarcomsForm } from "./forms/CreateMarcomsForm";

export const CreateMarcoms = () => {

    return (
        <>
            <MainLeftTitle title="Create Marcoms"/>
            <CreateMarcomsForm/>
        </>
    )
}